// Libraries
import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { useTranslation } from "react-i18next"
import classNames from "classnames"
// Assets
import PhoneWhite from "@Icons/PhoneWhite"
// Components
import Container from "@Components/Container/Container"
import NavbarItem, { NavbarItemProps } from "./NavbarItem"
// Hooks
import useWindowScroll from "@Hooks/useWindowScroll"
// Types
import { Tag } from "@Types/tags"
// Styles
import * as styles from "./Navbar.module.scss"

const Navbar = () => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isScrolled, setisScrolled] = useState(false)
  const scrollY = useWindowScroll()
  const { t, i18n } = useTranslation()

  const toggleExpandHandler = () => setIsExpanded(!isExpanded)

  const menuItems: NavbarItemProps[] = [
    {
      text: t("routes.about.text"),
      link: t("routes.about.link"),
      toggleExpandHandler,
    },
    {
      text: t("routes.equipment.text"),
      link: t("routes.equipment.link"),
      toggleExpandHandler,
    },
    {
      text: t("routes.prices.text"),
      link: t("routes.prices.link"),
      toggleExpandHandler,
    },
    {
      text: t("routes.contact.text"),
      link: t("routes.contact.link"),
      toggleExpandHandler,
    },
  ]

  const menuLanguages: NavbarItemProps[] = [
    {
      text: "EN",
      link: "/en/",
      isCurrentLang: i18n.language === "en",
      toggleExpandHandler,
    },
    {
      text: "PL",
      link: "/",
      isCurrentLang: i18n.language === "pl",
      toggleExpandHandler,
    },
  ]

  useEffect(() => {
    setisScrolled(scrollY > 50)
  }, [scrollY])

  return (
    <Container
      as={Tag.Nav}
      classes={classNames(styles.navbar, {
        [styles.navbarExpanded]: isExpanded,
        [styles.navbarScrolled]: isScrolled,
      })}
    >
      <Link
        to={t("routes.home.link")}
        className={styles.navbarLogo}
        onClick={() => setIsExpanded(false)}
      >
        <StaticImage
          src="../../../assets/images/logo.png"
          alt="Neuroclinikmed"
          loading="lazy"
          placeholder="blurred"
          formats={["auto", "webp"]}
          objectFit="contain"
          height={64}
        />
      </Link>
      <button
        onClick={toggleExpandHandler}
        className={styles.navbarButton}
        aria-label="menu"
      >
        <span></span>
        <span></span>
      </button>
      <ol className={styles.navbarMenu}>
        {menuItems.map((item, key) => (
          <NavbarItem key={item.link.slice(0, 3) + key} {...item} />
        ))}
        <li className={styles.navbarMenuService}>
          <span className={styles.languages}>
            {menuLanguages.map((item, key) => (
              <NavbarItem
                as="span"
                key={item.link.slice(0, 3) + key}
                {...item}
              />
            ))}
          </span>
          <NavbarItem
            as="span"
            text={
              <>
                <PhoneWhite />
                <span className="only-tablet">+48 572 573 737</span>
              </>
            }
            link={"tel:+48572573737"}
            isHiglited={"basic"}
            toggleExpandHandler={toggleExpandHandler}
          />
        </li>
      </ol>
    </Container>
  )
}

export default Navbar
